import { ContactModel } from "./contact.model";
import * as yup from "yup";

export interface LeadModel {
    id: number | null;
    created_by?: number | null;
    updated_by?: number | null;
    created_at: Date | null;
    updated_at: Date | null;
    leadDate: string | null;
    followUpDate: string | null;// (This can be the same as add task)
    siteVisitDate: string | null;// (This can be the same as add task)
    leadOwner: string | null;// (Team list here with patterns too)*
    leadStage: string | null;///status (Dropdown + Add manually)*
    leadSource: string | null;// (Dropdown with custom add)
    salesPerson: string | null;
    sourceOfPromotion: string | null;// (Lead source) (Dropdown + Add manually)
    sourceCampaign: string | null;
    propertyName: string | null;// - selectable (can be more than one) (Also check estimate tab here)
    contactId: number | null;
    contact?: ContactModel | null;
    contactName: any;
    notes: string | null
    flats: number[];
}

export class LeadClass implements LeadModel {
    id = null;
    created_by?= null;
    updated_by?= null;
    created_at = null;
    updated_at = null;
    leadDate:any = null;
    followUpDate: any = null;// (This can be the same as add task)
    siteVisitDate: any = null;// (This can be the same as add task)
    leadOwner:any = null;// (Team list here with patterns too)*
    leadStage = null;///status (Dropdown + Add manually)*
    leadSource = null;// (Dropdown with custom add)
    salesPerson = null;
    sourceOfPromotion: any = String()// (Lead source) (Dropdown + Add manually)
    sourceCampaign = null;
    propertyName = null;// - selectable (can be more than one) (Also check estimate tab here)
    contactId = null;
    contact = null;
    contactName: any = null;
    notes = null;
    flats = [];
}

export const leadValidationSchema = {
    contactName: yup.string().required("Name is required").nullable(),
    leadOwner: yup.string().required("LeadOwner is required").nullable(),
    sourceOfPromotion: yup.string().required("SourceOfPromotion is required").nullable(),
    leadDate: yup.string().required("Date is required").nullable(),
}